import React, { useState } from "react";
import "./SideBar.css";
import { Checkbox, Paper } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import QuestionList from "../../Pages/List";
import autgenerated from "../../../assets/Icons/auto-generated.png";
import chathistory from "../../../assets/Icons/chat-history.png";
import newchat from "../../../assets/Icons/Chat_plus_light.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import chaticon from "../../../assets/Icons/Chat-icon.png";
import { clearState, changeChat, clearHistoryDark } from "../../../Redux/features/MessageSlice";
import { FadeLoader } from "react-spinners";
const SideBar = ({ closeFile }) => {
  const [autoGeneratedChecked, setAutoGeneratedChecked] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);
  const [showAutoGenerated, setShowAutoGenerated] = useState(true);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const autoGeneratedQuestions = useSelector(
    (state) => state.messages.AutogeneratedQuetions
  );

  const autoGeneratedQuestionsLoading = useSelector(
    (state) => state.messages.AutogeneratedQuetionsLoading
  );

  const HistoryList = useSelector((state) => state.messages.chatHistory);

  const chatHistoryKeys = Object.keys(HistoryList) || [];
  const theme = useSelector((state) => state.messages.Theme);
  const dispatch = useDispatch();
  const handleAutoGeneratedToggle = () => {
    setAutoGeneratedChecked(!autoGeneratedChecked);
    setShowAutoGenerated(!showAutoGenerated);
  };
  const handleClearState = () => {
    closeFile();
    dispatch(clearState());
    dispatch(clearHistoryDark());
  };
  const handleClickHistory = (event) => {
    const pdfname = event.currentTarget.getAttribute("data-pdfname");
    setSelectedPdf(pdfname);
    dispatch(changeChat(pdfname));
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme === "dark_" ? "#181818" : "#ffffff",
        overflow: theme === "dark_" ? "hidden" : "scroll",
        borderRadius: "0px"
      }}
      className={`${theme}side_bar ${fadeIn ? "fade-in active" : "fade-in"}`}
    >
      <div className={`${theme}side_container`}>
        <button className={`my-button`} onClick={handleClearState}>
          <img style={{ height: "24px", width: "24px" }} src={newchat} alt="Chat Icon" />
          <span style={{ fontFamily: 'Inter' }}>New Chat</span>
        </button>

        {theme !== "dark_" && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              marginBottom: "30px"
            }}
          >
            <Checkbox
              checked={autoGeneratedChecked}
              onChange={handleAutoGeneratedToggle}
              color="default"
              style={{ color: '#333399', paddingLeft: "0" }}
            />

            <div
              style={{
                font: "roboto",
                fontSize: "12px",
                fontWeight: "500",
                lineHeight: "14px",
              }}
            >
              Auto-generated Questions
            </div>
          </div>
        )}
        <div>
        </div>
      </div>
      <div>
        {theme !== "dark_" &&
          autoGeneratedChecked &&
          (
            <div
              className={`${theme}auto-generated-content ${showAutoGenerated ? "active" : ""
                }`}
            >
              {autoGeneratedChecked && (
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "10px" }}>
                  <img
                    src={chathistory}
                    style={{ height: "24px", width: "24px" }}
                    alt="Generated Icon"
                  />
                  <span style={{ fontSize: "14px", color: "#787878", marginLeft: "10px" }}>Auto-generated Questions</span>
                </div>
              )}

              {autoGeneratedChecked && autoGeneratedQuestionsLoading === false ? (
                <div style={{ height: "100%" }}>
                  <QuestionList questions={autoGeneratedQuestions.slice(0, 3)} />
                </div>
              ) :
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "30px" }}>
                  <FadeLoader color="#0044cc" />
                </div>}
            </div>
          )
        }
        {theme !== "dark_" && chatHistoryKeys.length !== 0 && (
          <div style={{ display: "flex", flexDirection: "column", marginBottom: "15vh" }}>
            <div className="chat_history_container" style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "10px" }}>
              <img
                src={autgenerated}
                style={{ height: "24px", width: "24px" }}
                alt="Generated Icon"
              />
              <span style={{ fontSize: "14px", color: "#787878", marginLeft: "10px" }}>Chat history</span>
            </div>
            {chatHistoryKeys.map((pdfname) => (
              <div
                key={pdfname}
                data-pdfname={pdfname}
                onClick={handleClickHistory}
                style={{
                  backgroundColor:
                    selectedPdf === pdfname ? "#c0c0c0" : "#F5F5F5",
                  padding: "12px",
                  marginBottom: "1vh",
                  cursor: "pointer",
                  borderRadius: "10px",
                  transition: "background-color 0.3s",
                  width: "80%",
                  fontSize: "14px"
                }}
                onMouseEnter={() => setSelectedPdf(pdfname)}
                onMouseLeave={() => setSelectedPdf(null)} // Reset color on mouse leave
              >
                <img
                  src={chaticon}
                  alt="Chat Icon"
                  style={{
                    height: "20px",
                    marginRight: "8px",
                    verticalAlign: "middle",
                  }}
                />
                {pdfname}
              </div>
            ))}
          </div>
        )}
      </div>
    </Paper>
  );
};

export default SideBar;
